import { ApiClientProps } from "hooks/useApi";
import { environment } from "utilities/constants"; // Update the path to match the correct location of the constants file

export interface GetOnboardingAuthUrlResponse {
  authUrl: string;
  message: string;
}

interface GetOnboardingAuthUrl {
  locationId: string | undefined;
  partnerId: string | undefined;
  apiClient: ApiClientProps;
  posType: string | undefined;
}


async function getOnboardingAuthUrl({
  locationId,
  partnerId,
  apiClient,
  posType,
}: GetOnboardingAuthUrl): Promise<GetOnboardingAuthUrlResponse | undefined> {
  const { isValidOnboardingPos } = environment;

  if (posType && !isValidOnboardingPos.includes(posType)) {
    return;
  }


  if (!locationId || !partnerId) {
    throw new Error(
      "Network failure. Please check your connection and ensure your request includes all required parameters."
    );
  }
  
  const path = `/middleware-admin/partners/${partnerId}/locations/${locationId}/onboarding/${posType}/auth/url`;

  try {
    const response = await apiClient.get({
      path,
      noRetry: true,
    });

    if (!response) {
      return;
    }

    return response.resource;
  } catch (error) {
    throw new Error(error as string);
  }
}

export default getOnboardingAuthUrl;
